import React, { Component } from 'react';
import { slide as Menu } from 'react-burger-menu'
import { Link } from 'react-router'

import {} from './Header.css';

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false
        };
        
        this.state = {
            loaded: true
        };
    
    }
    showSettings (event) {
        event.preventDefault();
        alert('mailto:info@g-c3n4.com?subject=Web Site Enquiry&body=Hi g-C3N4 team,');
    }
    render() {
        if (this.state.loaded) {
            return (
                <div className="Header-container">
                
                    <Link className="Home-link" to="/">
                    <img src="/logo_w.png" className="Header-logo" alt="g-C3N4" />
                    <p className="Header-title">g-C3N4 - Graphitic Carbon Nitride</p>
                    </Link>
                    <Menu isOpen={ false }>
                        <Link id="Home" className="menu-item" to="/">Home</Link>
                        <Link id="news" className="menu-item" to="/news">News</Link>
                        <Link id="technical" className="menu-item" to="/technical">General Information</Link>
                        <Link id="research" className="menu-item" to="/research">Research</Link>
                        <Link id="opensource" className="menu-item" to="/opensource">Open Source</Link>
                        <Link id="blog" className="menu-item" to="/p/1">Blog</Link>
                        <Link id="about" className="menu-item" to="/about">About</Link>
                        <br/>
                        {/* <Link onClick={ this.showSettings } className="menu-item--small" to="/">Settings</Link> */}
                    </Menu>
                </div>
            );
        } else {
            return (
                <div>
                    Loading...
                </div>
            )
        }
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.js